import { useCallback, useEffect, useRef, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { videoSamplesGetByCategoryIds } from 'api/endpoints/video-sample';
import Button from 'components/Button';
import { ENUM_TYPE_REPORT_STATUS, ENUM_TYPE_VIDEO, ENUM_TYPE_VIDEO_CATEGORY } from 'constants/enum';
import { CATEGORY_VIDEOS_DAY } from 'constants/index';
import useVideoCategory from 'hooks/useVideoCategory';
import { convertToQueryString, handleError } from 'utils/helper';

import RecentExerciseVideoSelectionFileSample from './RecentExerciseVideoSelectionFileSample';

const RecentExerciseVideoSelectionDAY = ({
  isReportRegistration = false,
  setShowPopupAddExerciseVideo,
  setTypeVideo,
  selectedVideoDAY,
  handleRemoveVideo,
  isRecently,
  currentStatus,
}) => {
  const { t } = useTranslation();

  const { getVideoCategory } = useVideoCategory();

  const [categoriesDAY, setCategoriesDAY] = useState([]);

  const isCallingApi = useRef(false);

  const _getCategoriesDAY = async (_categoriesDAY) => {
    if (_categoriesDAY.length > 0) {
      const response = await getVideoCategory(ENUM_TYPE_VIDEO_CATEGORY.DAY);
      if (response) {
        const _categoriesDAYResult = _categoriesDAY.map((item) => {
          return {
            fileSample: item,
            category: response.find((category) => category.id === item.id),
          };
        });
        setCategoriesDAY(_categoriesDAYResult);
      }
    }
  };

  const _getVideoSamples = useCallback(async () => {
    if (selectedVideoDAY.length > 0) {
      if (!isCallingApi.current) {
        try {
          isCallingApi.current = true;
          const queryString = convertToQueryString({ ids: selectedVideoDAY });
          const response = await videoSamplesGetByCategoryIds(queryString);
          if (response && response.length > 0) {
            await _getCategoriesDAY(response);
          }
        } catch (error) {
          handleError(error);
        } finally {
          isCallingApi.current = false;
        }
      }
    } else {
      setCategoriesDAY([]);
    }
  }, [selectedVideoDAY]);

  useEffect(() => {
    _getVideoSamples();
  }, [_getVideoSamples]);

  return (
    <>
      <div className="flex justify-between items-center mb-6 px-2 h-10">
        <p className="font-bold text-xl">
          {isRecently
            ? t('LATEST_WORKOUT_VIDEO_RECENTLY')
            : isReportRegistration
              ? t('LATEST_WORKOUT_VIDEO_REPORT_REGISTRATION')
              : t('LATEST_WORKOUT_VIDEO')}
        </p>
        {isReportRegistration && currentStatus === ENUM_TYPE_REPORT_STATUS.PROCESSING && (
          <Button
            type="button"
            color="primary-outline"
            text="運動の動画を追加"
            className="!rounded-full space-x-4 px-5"
            icon={<img src={require('assets/resources/PlusPrimary.svg').default} alt="plus icon" width={18} height={18} />}
            onClick={() => {
              setShowPopupAddExerciseVideo(true);
              setTypeVideo?.(ENUM_TYPE_VIDEO.DAY);
            }}
          />
        )}
      </div>
      <div className="mt-4 overflow-auto h-[calc(100%-64px)] px-2">
        <div className="flex flex-col space-y-6">
          {categoriesDAY.map((item, index) => (
            <RecentExerciseVideoSelectionFileSample
              key={`video-category-day-${index}`}
              dataCategory={item.category || null}
              dataVideoSample={item.fileSample || null}
              handleRemoveVideo={handleRemoveVideo}
              isReportRegistration={isReportRegistration}
              categoryVideo={CATEGORY_VIDEOS_DAY}
              typeVideo={ENUM_TYPE_VIDEO.DAY}
              currentStatus={currentStatus}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default RecentExerciseVideoSelectionDAY;
